<template>
  <div id="nomination-committee-create">
    <v-card
      class="pa-4 elevation-6"
      style="min-height: 100vh; overflow-y: auto; border-radius: 16px"
    >
      <!-- Header -->
      <v-app-bar color="primary" dark dense flat rounded>
        <v-toolbar-title class="text-h6 font-weight-bold">
          {{ PageTitle }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="closePrompt">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-app-bar>

      <!-- Form -->
      <v-form ref="form1" v-model="valid1" lazy-validation class="mt-6">
        <v-container>
          <!-- Section: Member Info -->
          <h5 class="mb-4 font-weight-bold text--primary">🔹 Member Info</h5>
          <v-row dense>
            <!-- Member Type -->
            <v-col cols="12" sm="6" md="4">
              <v-select
                v-model="row.RoleId"
                :items="MemberTypeOptions"
                :rules="[(v) => !!v || 'Member type is required']"
                outlined
                dense
                clearable
                label="Member Type *"
              ></v-select>
            </v-col>

            <!-- Membership ID -->
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="row.MembershipId"
                :rules="MemberIdRules"
                outlined
                dense
                clearable
                type="number"
                label="Membership ID *"
              ></v-text-field>
            </v-col>

            <!-- Search Button -->
            <v-col cols="4" class="pl-2">
              <v-btn color="success" dark @click="getMemberRecords">
                <v-icon left>mdi-magnify</v-icon> Search
              </v-btn>
            </v-col>
          </v-row>

          <!-- Section: Member Details -->
          <v-row dense v-if="member.MemberName" class="mt-6">
            <v-col cols="12" md="6" lg="4">
              <h5 class="mb-3 font-weight-bold text--primary">
                🔹 Member Details
              </h5>
              <v-card
                class="pa-4 elevation-8"
                color="#f9fbff"
                style="border-radius: 16px"
              >
                <v-row no-gutters align="center">
                  <!-- Photo -->
                  <v-col cols="3" class="text-center">
                    <v-img
                      v-if="member.Photo"
                      :src="member.Photo"
                      height="90"
                      width="90"
                      contain
                      class="rounded-circle elevation-6"
                    ></v-img>
                    <v-avatar size="90" v-else color="grey lighten-3">
                      <v-icon large color="grey">mdi-account</v-icon>
                    </v-avatar>
                  </v-col>

                  <!-- Info -->
                  <v-col cols="9">
                    <div class="text-h6 font-weight-bold">
                      {{ member.MemberName }}
                      <span class="text--secondary"
                        >({{ member.MembershipId }})</span
                      >
                    </div>
                    <div><b>Email:</b> {{ member.EmailId || "NA" }}</div>
                    <div><b>Mobile:</b> {{ member.MobileNo || "NA" }}</div>
                    <div class="mt-2">
                      <b>Aadhaar Verification:</b>
                      <v-chip
                        :color="member.AadhaarTextColor"
                        small
                        class="ml-2 white--text"
                      >
                        {{ member.AadhaarVerifiedTxt }}
                      </v-chip>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-container>

        <!-- Submit Button -->
        <v-card-actions class="justify-center mt-10">
          <v-btn
            @click.prevent="confirmAlert"
            :loading="SubmitFlag"
            large
            rounded
            class="px-12 white--text"
            style="background: linear-gradient(45deg, #1976d2, #42a5f5)"
          >
            <v-icon left>mdi-check-circle</v-icon> Submit
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";
import UploadSelectedMemberDocument from "@/view/pages/members/UploadSelectedMemberDocument.vue";
import UploadSelectedMemberPhoto from "@/view/pages/members/UploadSelectedMemberPhoto.vue";

export default {
  mixins: [common],
  components: {
    UploadSelectedMemberDocument,
    UploadSelectedMemberPhoto,
  },
  props: {
    addRecordPrompt: {
      type: Boolean,
      required: true,
    },
    pageDescription: {
      type: String,
    },
    row: {
      type: Object,
    },
  },
  data() {
    return {
      valid1: true,

      search: "",
      selected: [],
      tableSelectFlag1: false,
      SubmitFlag: false,
      ResultFlag: false,

      member: {},

      memberDocumentPrompt: false,
      memberPhotoPrompt: false,

      rows: [],
      tableColumns1: [],
      records: [],

      alert: {},

      ProgessStart: 0,
      uploadPercentage: 0,

      SuccessMessageTxtFlag: 0,
      SuccessMessageTxt: "",

      ErrorMessageTxtFlag: 0,
      ErrorMessageTxt: "",

      ResultFlag: false,
      LoadingFlag: false,
      StartupLoadingFlag: false,

      AllMembers: [],

      MemberIdRules: [(v) => !!v || "Membership ID is required"],
      MemberId: "",
      MemberIdOptions: [],
      MemberIdOptionsLoading: false,

      MemberType: "",
      MemberTypeOptions: [
        { text: "--Select--", value: "" },
        { text: "Nomination Committee Member", value: 311 },
        { text: "Nomination Committee Chairman", value: 310 },
        { text: "Election Officer", value: 196 },
        { text: "Zone Award Judging Head Table", value: 174 },
      ],

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      JciYearCode: "",
      YearName: "",
    };
  },
  computed: {},
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });
        this.JciYearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        this.pageData();
      }
    },
    rows: function () {
      console.log("watch rows");
      var n1 = this.rows.length;
      var flag = n1 == 0 ? 0 : 1;
      console.log("n1=" + n1 + ", flag=" + flag);
      this.records = this.rows[0];
    },
  },
  created() {
    // this.initialize()
  },
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "nomination_committee",
        Action: "edit",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
      this.pageData();
      this.getMemberRecords();
    },
    pageData() {
      console.log("pageData called");
      console.log("LomCode=" + this.LomCode);
      console.log("ZoneCode=" + this.ZoneCode);
    },
    getMemberRecords() {
      console.log("getMemberRecords called");

      var MemberId = this.row.MembershipId;
      console.log({ MemberId });

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/nominate-member-subscription/info";
      var upload = {
        UserInterface: 2,
        Membership: MemberId,
      };
      console.log("upload=" + JSON.stringify(upload));
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );
      console.log("recordData:", this.recordData);

      const thisIns = this;
      var output = "";
      var records = {};
      var flag = 0;
      var data = {};

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        }.bind(this),
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));

          // thisIns.pageLoadingOff()
          thisIns.LoadingFlag = false;

          output = response.data.output;
          flag = response.data.flag;
          console.log("output=" + output + ", flag=" + flag);

          records = response.data.records;
          console.log({ records });

          if (flag == 1) {
            thisIns.member = records;
            thisIns.toast("success", output);
          } else {
            thisIns.toast("error", output);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.LoadingFlag = false;
        });
    },
    validate() {
      console.log("validate called");
      this.$refs.form1.validate();
    },
    reset() {
      console.log("reset called");
      this.$refs.form1.reset();
    },
    resetValidation() {
      console.log("resetValidation called");
      this.$refs.form1.resetValidation();
    },
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hideDialog", this.ResultFlag);
    },
    resetMessageTxt() {
      console.log("resetMessageTxt called");
      this.ErrorMessageTxt = 0;
      this.ErrorMessageTxtFlag = "";
      this.SuccessMessageTxtFlag = 0;
      this.SuccessMessageTxt = "";
    },
    onFileSelected(event, k) {
      console.log("onFileSelected called");
      var n1 = this.uploadedImages.length;
      var file = event.target.files[0];
      console.log("k=" + k + ", event=" + JSON.stringify(file));
      this.uploadedImages[k] = file;
    },
    addNewRow(tableId) {
      console.log("addNewRow called");
      console.log("tableId=" + tableId);

      if (tableId == 2) {
        var n1 = this.AllMembers.length;
        console.log("n1=" + n1);
        // if (n1 < 30) {
        this.AllMembers.push({
          YearwiseOfficesHeldId: null,
          MemberId: 0,
          MemberName: "",
          NominationDesignation: 0,
          Designation: "",
        });
        // }
      }
    },
    deleteRow(tableId, index, tr) {
      console.log("deleteRow called");
      console.log(
        "tableId=" + tableId + ", index=" + index + ", tr=" + JSON.stringify(tr)
      );
      if (index > -1) {
        if (tableId == 2) {
          this.AllMembers.splice(index, 1);
        }
      }
    },
    getMemberIdOptions() {
      console.log("getMemberIdOptions called");
      this.MemberIdOptionsLoading = true;
      var selectbox1_source = "MemberId";
      var selectbox1_destination = "MemberIdOptions";
      var selectbox1_url = "api/members/options";
      var selectbox1_conditions_array = {
        UserInterface: 7,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    confirmAlert() {
      var validate1 = this.$refs.form1.validate();
      console.log("validate1=" + validate1);
      if (validate1) {
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: `Save`,
          confirmButtonColor: "#3085d6",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#d33",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.submitForm();
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      } else {
        this.toast("error", "Kindly fill the required fields", true);
      }
    },
    submitForm() {
      // add todo in store and clear all fields in dialog
      console.log("submitForm called");

      // this.resetMessageTxt();
      var MemberId = this.member.MemberId;
      console.log("MemberId=" + MemberId);

      var JudgeId = this.row.JudgeId;
      console.log("JudgeId=" + JudgeId);

      var result = this.$refs.form1.validate();
      console.log("result=" + result);

      if (result && MemberId !== "") {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/judge/update";
        var upload = {
          UserInterface: 1,
          Judge: JudgeId,
          Membership: this.row.MembershipId,
          Role: this.row.RoleId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        this.LoadingFlag = true;

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        // thisIns.pageLoadingOn()

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            // thisIns.ProgessStart = 0;
            thisIns.LoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              // thisIns.SuccessMessageTxtFlag = 1;
              // thisIns.SuccessMessageTxt = output;
              thisIns.ResultFlag = true;
              thisIns.closePrompt();
              // thisIns.AllMembers = [];
              // thisIns.ResultFlag = false;
              thisIns.sweetAlert("success", output, true);
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.LoadingFlag = false;
          });
      } else {
        console.log("some errors occured");
        var message = "";
        if (!MemberId) {
          message += "Please search the Member Id and Submit";
        }

        if (message !== "") {
          this.sweetAlert("error", message, false);
        }
      }
    },
  },
  beforeMount() {
    console.log("beforeMount called");
    this.refreshPageData();
  },
};
</script>
<style lang="scss">
#nomination-committee-edit {
  .v-card {
    border-radius: 14px;
  }
  .v-toolbar__title {
    font-weight: 600;
  }
  .v-card .v-chip {
    font-size: 0.85rem;
    font-weight: 500;
  }
}
</style>
